function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { selx } from "clsx";
import { ButtonEl } from "common/components/button";
import { InputEl } from "common/components/input";
import { ButtonTheme } from "common/components/button/constants";
import { Necessary, ValidationStatus } from "../input/types";
import overrides from "./override.inline.styl";
import styles from "./index.module.styl";
export function template() {
  const {
    value,
    errors
  } = this.state;
  const disabled = this.attr("disabled");
  const readOnly = this.attr("readonly");
  const theme = this.attr("theme");
  const busy = this.attr("busy");
  const maxLength = this.attr("maxlength");
  const minLength = this.attr("min");
  const inputAttrs = _objectSpread(_objectSpread(_objectSpread({
    placeholder: this.attr("placeholder"),
    necessary: Necessary.Required
  }, maxLength ? {
    maxlength: maxLength
  } : {}), minLength ? {
    min: minLength.toString()
  } : {}), {}, {
    "validation-status": errors.length > 0 ? ValidationStatus.Invalid : ValidationStatus.Default,
    "error-message": this.helpers.getErrorMessage()
  });
  const buttonAttrs = {
    disabled: disabled || !this.helpers.isValid(),
    theme: ButtonTheme.Primary
  };
  if (disabled || busy) {
    inputAttrs.disabled = true;
  }
  if (readOnly) {
    inputAttrs.readonly = true;
  }
  if (theme) {
    buttonAttrs.theme = theme;
  }
  if (this.attr("icon") || this.attr("busy")) {
    buttonAttrs.icon = this.attr("busy") ? "spinner" : this.attr("icon");
  }
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpInputGroupContainer), attrs: {
    elref: "input-group-container"
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(InputEl, { sel: selx(styles.mpInputGroupInput), attrs: _objectSpread(_objectSpread({
    elref: "input-group-input"
  }, inputAttrs), {}, {
    "style-override": overrides
  }), props: {
    value
  }, on: {
    input: this.helpers.setValue,
    keyup: this.helpers.submitIfEnter,
    blur: this.helpers.checkErrors,
    focus: this.helpers.handleFocus
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(ButtonEl, { sel: selx("mp-button", styles.mpInputGroupBtn), attrs: buttonAttrs, on: {
    click: this.helpers.submit
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, this.attr("busy") ? null : this.attr("label")));
}
